// Wave 3B — Commit 3ab
// Chip at the top of the results page letting the user toggle between
// "Online only" and "Nearby stores first". Hidden entirely when the user's
// offline-shopping location is missing or stale (not fresh) — the chip is
// meaningless without an active offline-shopping state.

interface OfflineShoppingChipProps {
  mode: "online" | "nearby";
  isFresh: boolean;
  onChange: (mode: "online" | "nearby") => void;
}

export function OfflineShoppingChip({
  mode,
  isFresh,
  onChange,
}: OfflineShoppingChipProps) {
  if (!isFresh) return null;

  const options: Array<{ id: "online" | "nearby"; label: string }> = [
    { id: "online", label: "Online only" },
    { id: "nearby", label: "Nearby first" },
  ];

  return (
    <div
      role="tablist"
      aria-label="Shopping mode"
      style={{
        display: "inline-flex",
        padding: 3,
        borderRadius: 999,
        background: "#F1EFE8",
        border: "1px solid #E4DFD5",
        gap: 2,
      }}
    >
      {options.map((opt) => {
        const active = opt.id === mode;
        return (
          <button
            key={opt.id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.id)}
            style={{
              padding: "6px 12px",
              borderRadius: 999,
              border: "none",
              background: active ? "#2C2820" : "transparent",
              color: active ? "#FFFCF8" : "#2C2820",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default OfflineShoppingChip;
